<template>
  <div class="simul">
    <SimulForm :simul="simul" />
  </div>
</template>

<script>
import SimulForm from "@/components/simuls/SimulForm.vue";
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";

export default {
  components: { SimulForm },

  name: "SimulCreateOrEdit",

  title() {
    return this.simulId ? "Update simul:" : "Create new simul";
  },

  data() {
    return {
      simul: null,
    };
  },

  watch: {
    permission() {
      if (this.permission.admin || this.permission.hostSimul) {
        return;
      }

      this.$router.push({
        name: "simuls",
      });
    },
  },

  computed: {
    ...mapGetters({
      permission: "getPermission",
    }),

    simulId() {
      return this.$route.params.simulId;
    },
  },

  methods: {},

  async created() {
    await this.$bind("simul", firestore.collection("simuls").doc(this.simulId));
  },
};
</script>

<style scoped></style>
